<template>
  <Button v-bind="$attrs" :loading="loadingStatus" :disabled="loadingStatus" @click="handleClick" class="ybutton">
    <slot></slot>
  </Button>
</template>
<script setup>
  import { ref } from 'vue'

  const emit = defineEmits(['click'])
  const props = defineProps({
    yLoading: {
      type: Boolean,
      default: true
    }
  })
  let loadingStatus = ref(false)
  const handleClick = () => {
    if (props.yLoading) {
      loadingStatus.value = true
    }
    emit('click', () => {
      loadingStatus.value = false
    })
  }
</script>
<style less scoped>
</style>